import React, { createContext, useContext } from 'react';
import { useImpressionContainer, useImpressionItem } from '@fiverr-private/impressionable';
import { useBigQuery } from '../BigQuery';

interface BigQueryImpressionContainerProps {
  intersectionThreshold: number;
  children: React.ReactNode;
}

export const BigQueryImpressionContainer = ({ intersectionThreshold, children }: BigQueryImpressionContainerProps) => {
  const bigQuery = useBigQuery();

  const [ref, impressionId] = useImpressionContainer<HTMLDivElement>();

  useImpressionItem({
    sendImpressionToBQ: false, // We're sending the impression event manually.
    intersectionThreshold,
    selfRef: ref,
    selfId: impressionId,
    onImpression: (impressionArgs) => {
      bigQuery.trackImpressionOnContainer({ impressionArgs });
    },
  });

  return (
    <ImpressionIdContext.Provider value={impressionId}>
      <div ref={ref}>{children}</div>
    </ImpressionIdContext.Provider>
  );
};

const ImpressionIdContext = createContext<string | null>(null);

export const useContainerImpressionId = (): string => {
  const impressionId = useContext(ImpressionIdContext);
  if (!impressionId) {
    throw new Error('"useContainerImpressionId" must be used inside "BigQueryImpressionContainer"');
  }
  return impressionId;
};
